import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './product-status.module.scss';
import '@/style/fonts.module.scss';
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";

export type ProductStatusProps = {
    type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM | LayoutStyleTypes.TYPE_MD;
    status?: 'in-stock' | 'out-stock' | 'discontinued' | string;
    className?: string;
};

export const ProductStatus: React.FC<ProductStatusProps> = ({ type = LayoutStyleTypes.TYPE_LG, status = '', className }) => {
    const { t } = useTranslation();

    let text = '--';
    let statusClass = styles.out;
    if (status === 'in-stock') {
        text = t('wwx593qvd0zl1lnj.in-stock', 'In stock');
        statusClass = styles.success;
    } else if (status === 'out-stock') {
        text = t('ou8a50qhq8z03edd.available-for-order', 'Available for order');
        statusClass = styles.success;
    } else if (status === 'out-stock-not-available-for-order') {
        text = t('ou8a50qhq8z03eda.out-stock', 'Out stock');
        statusClass = styles.out;
    } else if (status === 'discontinued') {
        text = t('ou8a50qhq8z03eda.out-stock', 'Out stock');
        statusClass = styles.out;
    }

    return (
        <div
            className={classNames(
                styles.root,
                styles.status,
                statusClass,
                styles[`type-${type}`],
                className
            )}
        >
            {text}
        </div>
    );
};

export default ProductStatus;
